const data = [{
        "content": "Tie Qiu, Feng Xia, Lianbo Song, Jie Liu. A Distributed Ordering Method and System. (Patent No. CN201410323920.7)",
        "id": 1,
        "language": "英语"
    },
    {
        "content": "Tie Qiu, Fengqi Li, Jie Liu, Zhen Bao. Automatic Inspection Robot Cart and Shopping System. (Patent No. ZL201410323069.8)",
        "id": 2,
        "language": "英语"
    },
    {
        "content": "Tie Qiu, Fengqi Li, Lu Zhang, Rongxin Zhou. An Automatic Tracking Robot Control Device and Automatic Tracking Robot. (Patent No. ZL201410323741.3)",
        "id": 3,
        "language": "英语"
    },
    {
        "content": "Fengqi Li, Tie Qiu, Jie Liu, Zhen Bao. Shopping Navigation Robot. (Patent No. ZL201410323931.5)",
        "id": 4,
        "language": "英语"
    },
    {
        "content": "Fengqi Li, Tie Qiu, Xinyu Zhang, Lianbo Song. Path Planning Method, Device and Robot for Smart Shopping. (Patent No. ZL201410324284.X)",
        "id": 5,
        "language": "英语"
    },
    {
        "content": "邱铁, 宁兆龙，张玉爽，李明楚，陈宁，李晓芳. 一种用于无线传感器网的时间同步方法，授权公告日：2018.12.13. (专利号：ZL201610221092.5)",
        "id": 12,
        "language": "汉语"
    },
    {
        "content": "邱铁, 侯刚， 段田田， 肖威威. 智能老人服务机器人，授权公告日：2018.9.4. (专利号：ZL201610643917.2)",
        "id": 13,
        "language": "汉语"
    },
    {
        "content": "夏锋, 邱铁，赵傲阳，郑凯宇. 一种无线传感器网络拓扑构建方法，授权公告日：2018.9.5. (专利号：ZL201610041983.2)",
        "id": 14,
        "language": "汉语"
    },
    {
        "content": "邱铁，李凤岐, 刘杰, 包震. 全自动巡线机器人购物车及购物系统，授权公告日：2016.6.29. (专利号：ZL201410323069.8)",
        "id": 15,
        "language": "汉语"
    },
    {
        "content": "邱铁, 李凤岐, 张璐, 周荣鑫. 一种自动跟踪机器人控制装置及自动跟踪机器人，授权公告日：2015.12.30. (专利号：ZL201410323741.3)",
        "id": 16,
        "language": "汉语"
    }
]

export default data;